import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EntityDataObject } from 'models/service';

export const leaveCommunity = async ({ id }: { id: string }) =>
  apiClient.delete<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.community.leave(id));
